import { Directive } from '@angular/core';

@Directive({
  selector: '[heroInputPositiveBudget]',
})
export class InputPositiveBudgetDirective {
  constructor() {}
}
